export default __webpack_public_path__ + "static/media/giraffe.b699b321.png";